import { useAuth } from "@/context/auth-provider";
import { useQuery } from "react-query";
import { TransactionTypeAPI } from "../services/transaction.service";
import { TransactionType } from "../types/transaction.type";
import delayPromise from "@/utils/delay-promise";
import { MOCK_TRANSACTION_TYPE_DATA } from "@/data/types";

const useTransactionTypes = (params: { enabled?: boolean } = {}) => {
  const { user } = useAuth();
  const isAuthenticated = !!user;
  const { enabled = true } = params;

  const fetchTransactionTypes = async () => {
    if (!isAuthenticated) return [];
    const response = await TransactionTypeAPI.getAll({ ordering: "id" });
    return response?.data?.results ?? [];
  };

  const { data: transactionTypes, isLoading: loadingTransactionTypes } =
    useQuery<TransactionType[]>(
      ["transaction_types"],
      delayPromise(fetchTransactionTypes, 500),
      {
        cacheTime: 60 * 60 * 1000, // 1 hour
        refetchOnWindowFocus: false,
        keepPreviousData: true,
        // initialData: MOCK_TRANSACTION_TYPE_DATA,
        enabled: isAuthenticated && enabled,
      }
    );

  return { transactionTypes, loadingTransactionTypes };
};
export default useTransactionTypes;
